// Halo Mobile Priority Script v11 - Clean version without thumbnail handler
(function() {

  // ── MUTATION OBSERVER — removes duplicate nav instantly ────────
  function startDuplicateObserver() {
    var sidebarNav = document.querySelector('#navigation-mobile .site-nav-mobile.nav');
    if (!sidebarNav || sidebarNav._observing) return;
    sidebarNav._observing = true;

    var observer = new MutationObserver(function() {
      var navs = sidebarNav.querySelectorAll('.header__inline-menu');
      if (navs.length > 1) {
        for (var i = 1; i < navs.length; i++) {
          navs[i].parentNode.removeChild(navs[i]);
        }
      }
    });

    observer.observe(sidebarNav, { childList: true, subtree: true });
  }

  // ── CLOSE HANDLER ─────────────────────────────────────────────
  if (!document._priorityCloseBound) {
    document._priorityCloseBound = true;
    document.addEventListener('click', function(e) {
      if (window.halo) return;
      var target = e.target;
      var isClose = (
        target.classList.contains('background-overlay') ||
        !!target.closest('.background-overlay') ||
        target.classList.contains('halo-sidebar-close') ||
        !!target.closest('.halo-sidebar-close') ||
        target.hasAttribute('data-menu-close-sidebar') ||
        !!target.closest('[data-menu-close-sidebar]') ||
        target.hasAttribute('data-search-close-sidebar') ||
        !!target.closest('[data-search-close-sidebar]') ||
        target.hasAttribute('data-close-auth-sidebar') ||
        !!target.closest('[data-close-auth-sidebar]')
      );
      if (isClose) {
        e.preventDefault();
        document.body.classList.remove('menu_open', 'open_search_mobile', 'auth-sidebar-show');
      }
    });
  }

  // ── SUBMENU TOGGLE ────────────────────────────────────────────
  if (!document._prioritySubmenuBound) {
    document._prioritySubmenuBound = true;

    document.addEventListener('click', function(e) {
      if (window.halo) return;
      var link = e.target.closest('.menu_mobile_link');
      if (!link) return;
      if (link.classList.contains('list-menu__item--end')) return;
      e.preventDefault();
      e.stopPropagation();
      var parentLi = link.parentElement;
      if (!parentLi) return;
      var siblings = parentLi.parentElement ? parentLi.parentElement.children : [];
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] !== parentLi) {
          siblings[i].classList.remove('is-open');
          siblings[i].classList.add('is-hidden');
        }
      }
      parentLi.classList.remove('is-hidden');
      parentLi.classList.add('is-open');
    });

    document.addEventListener('click', function(e) {
      if (window.halo) return;
      var backBtn = e.target.closest('.nav-title-mobile');
      if (!backBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var el = backBtn;
      for (var i = 0; i < 5; i++) {
        el = el.parentElement;
        if (!el) break;
        if (el.tagName === 'LI' && el.classList.contains('is-open')) {
          el.classList.remove('is-open');
          var sibs = el.parentElement ? el.parentElement.children : [];
          for (var j = 0; j < sibs.length; j++) {
            sibs[j].classList.remove('is-hidden');
          }
        }
      }
    });
  }

  // ── TOOLBAR SEARCH/ACCOUNT ────────────────────────────────────
  if (!document._priorityToolbarBound) {
    document._priorityToolbarBound = true;
    document.addEventListener('click', function(e) {
      if (window.halo) return;
      var toolbarSearch = e.target.closest('.bottom-bar [data-search-mobile]');
      var toolbarAccount = e.target.closest('.bottom-bar [data-open-auth-sidebar]');
      if (toolbarSearch) {
        e.preventDefault();
        document.body.classList.add('open_search_mobile');
      }
      if (toolbarAccount) {
        e.preventDefault();
        document.body.classList.add('auth-sidebar-show');
      }
    });
  }

  // ── PRODUCT CUSTOM INFO POPUP (? buttons) ─────────────────────
  if (!document._priorityPopupBound) {
    document._priorityPopupBound = true;
    document.addEventListener('click', function(e) {
      if (window.halo) return;
      var infoBlock = e.target.closest('[data-custom-information]');
      if (!infoBlock) return;

      var popup = document.getElementById('halo-product-custom-information');
      if (!popup) return;

      var titleEl = infoBlock.querySelector('.title');
      var contentEl = infoBlock.querySelector('.product-customInformation__popup');
      if (!contentEl || !contentEl.innerHTML.trim()) return;

      popup.classList.add('is-show');
      var popupTitle = popup.querySelector('.halo-popup-title');
      var popupContent = popup.querySelector('.halo-popup-content');
      if (popupTitle) popupTitle.textContent = titleEl ? titleEl.innerText : '';
      if (popupContent) popupContent.innerHTML = contentEl.innerHTML;
      document.body.classList.add('is-custom-information');
    });

    document.addEventListener('click', function(e) {
      if (window.halo) return;
      if (!document.body.classList.contains('is-custom-information')) return;
      var closeBtn = e.target.closest('[data-close-custom-information]');
      var clickedPopup = e.target.closest('#halo-product-custom-information');
      var clickedInfo = e.target.closest('[data-custom-information]');
      if (closeBtn || (!clickedPopup && !clickedInfo)) {
        document.body.classList.remove('is-custom-information');
        var popup = document.getElementById('halo-product-custom-information');
        if (popup) popup.classList.remove('is-show');
      }
    });
  }

  function attachHandlers() {
    var body = document.body;

    // ── HAMBURGER MENU ──────────────────────────────
    var menuBtn = document.querySelector('.mobileMenu-toggle');
    if (menuBtn && !menuBtn._priorityBound) {
      menuBtn._priorityBound = true;
      menuBtn.addEventListener('click', function(e) {
        if (window.halo) return;
        e.preventDefault();
        body.classList.add('menu_open');
      });
    }

    // ── HEADER SEARCH ───────────────────────────────
    var searchBtn = document.querySelector('.section-header-mobile [data-search-mobile]');
    if (searchBtn && !searchBtn._priorityBound) {
      searchBtn._priorityBound = true;
      searchBtn.addEventListener('click', function(e) {
        if (window.halo) return;
        e.preventDefault();
        body.classList.add('open_search_mobile');
      });
    }

    // ── ACCOUNT ─────────────────────────────────────
    var accountBtns = document.querySelectorAll('[data-open-auth-sidebar]');
    accountBtns.forEach(function(btn) {
      if (!btn._priorityBound) {
        btn._priorityBound = true;
        btn.addEventListener('click', function(e) {
          if (window.halo) return;
          e.preventDefault();
          body.classList.add('auth-sidebar-show');
        });
      }
    });

    // ── DUPLICATE NAV OBSERVER ──────────────────────
    startDuplicateObserver();
  }

  // Try immediately
  attachHandlers();

  // Try again when DOM ready
  document.addEventListener('DOMContentLoaded', attachHandlers);

  // Keep trying every 100ms for first 5 seconds
  var tries = 0;
  var interval = setInterval(function() {
    attachHandlers();
    tries++;
    if (tries > 50) clearInterval(interval);
  }, 100);

})();